import {
  DELETE_ENTRIE,
  GET_ENTRIES,
  GET_ENTRIE,
  GET_ENTRIE_UUID,
  CLEAR_ENTRIE,
  UPDATE_ENTRIE,
  AGE_FILTER,
  SEARCH_FILTER,
  CLEAR_AGE_FILTER,
  CLEAR_SEARCH_FILTER,
  SET_LIST_VIEW,
  FILTER_TABLE,
  CLEAR_FILTER_TABLE,
  SET_FORM_MODAL,
  GET_ENROLLMENT_SITES,
  FILTER_ENROLLMENT_SITES,
  CLEAR_FILTER_ENROLLMENT_SITES,
  ADD_NOTES,
  GET_INTERESTNOTES,
  CLEAR_TRANSFER_FILTER,
  CLEAR_NOTINTEREST_FILTER,
  NOTINTEREST_FILTER,
  TRANSFER_FILTER,
  GET_TRANSFER_REGISTRATIONS,
  GET_ENROLLMENT_ENTRIES,
   STORE_NAVIGATION_STATE,
  RESTORE_NAVIGATION_STATE,
  SET_LOADING,
  SET_CURRENT_PAGE,
  GET_INTENTRIES_OPTIMIZED,
  SET_LOADING_OPTIMIZED,
} from "../types";

const adminInterestReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ENROLLMENT_SITES:
      return {
        ...state,
        searchSites: payload,
      };
    case FILTER_ENROLLMENT_SITES:
      return {
        ...state,
        filteresSearchSites: state.searchSites.filter((item) => {
          const escapedPayload = payload.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const regex = new RegExp(`${escapedPayload}`, "gi");
          return (
            item.name.match(regex) ||
            item.charter.match(regex) ||
            item.address.address_1.match(regex) ||
            item.address.city.match(regex) ||
            item.address.state.match(regex) ||
            item.address.zip.match(regex)
          );
        }),
      };
    case CLEAR_FILTER_ENROLLMENT_SITES:
      return {
        ...state,
        filteresSearchSites: [],
      };

    case ADD_NOTES:
      return {
        ...state,
        InterestNotes: [...state.InterestNotes, payload],
      };

    case GET_INTERESTNOTES:
      return {
        ...state,
        InterestNotes: payload,
      };

    case GET_TRANSFER_REGISTRATIONS:
      return {
        ...state,
        registrations: payload.regularRegistrations,
        loading: false,
      };

    case GET_ENTRIES:
      return {
        ...state,
        entries: payload,
        loading: false,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_ENTRIE:
      return {
        ...state,
        entrie: payload,
      };
    case GET_ENTRIE_UUID:
      return {
        ...state,
        entriebyuuid: payload,
        loading: false
      };
    case CLEAR_ENTRIE:
      return {
        ...state,
        entrie: {},
      };
    case AGE_FILTER:
      return {
        ...state,
        filteredEntries:
          state.searchFiltered.length > 0
            ? state.searchFiltered.filter((item) => {
              return payload === "Under" ? item.age < 18 : item.age >= 18;
            })
            : state.entries.filter((item) => {
              return payload === "Under" ? item.age < 18 : item.age >= 18;
            }),
        ageFiltered: state.entries.filter((item) => {
          return payload === "Under" ? item.age < 18 : item.age >= 18;
        }),
        ageOver: payload === "Over",
        ageUnder: payload === "Under",
      };

    case NOTINTEREST_FILTER:
      return {
        ...state,
        NotinterestedFiltered:
          payload === "notInterested"
            ? state.entries.filter((item) => item.status === "Not Interested")
            : state.NotinterestedFiltered,
        filteredEntries:
          payload === "notInterested"
            ? state.entries.filter((item) => item.status === "Not Interested")
            : state.entries, // fallback to all entries if none found
        InterestListStatus: {
          ...state.InterestListStatus,
          notInterested: true,

        },
      };
      case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload
      };
    // Add this case to your adminInterestReducer switch statement

    case GET_ENROLLMENT_ENTRIES:
      return {
        ...state,
        entries: payload,
        filteredEntries: payload, // Initialize filtered entries with all data
        loading: false,
        totalCount: action.totalCount,
        appliedFilters: action.appliedFilters,        
        // Store current filter values for UI state
        currentFilters: {
          learningCenterCharter: action.learningCenterCharter,
          learningCenterName: action.learningCenterName,
          enrollstatus: action.enrollstatus,
          age: action.age,
          searchText: action.searchText,
          startDate: action.startDate,
          endDate: action.endDate,
          allTime: action.allTime,
        },
        currentPage: action.page,
           pageSize: action.pageSize,
         previousState: state.previousState
      };
      case GET_INTENTRIES_OPTIMIZED:
      return {
        ...state,
        IntntriesOptimized: payload,
        loadingOpt: false,
       
      };
       case SET_LOADING_OPTIMIZED:
            return {
              ...state,
              loadingOpt: true,
            };
      // ADD THESE NEW CASES:
    case STORE_NAVIGATION_STATE:
      return {
        ...state,
        // Store current state as previousState
        previousState: {
          entries: state.entries,
          currentPage: state.currentPage,
          totalCount: state.totalCount,
          appliedFilters: state.appliedFilters,
          currentFilters: state.currentFilters,
          searchText: state.searchText,
          filteredEntries: state.filteredEntries,
        }
      };

    case RESTORE_NAVIGATION_STATE:
      if (state.previousState) {
        return {
          ...state,
          entries: state.previousState.entries,
          currentPage: state.previousState.currentPage,
          totalCount: state.previousState.totalCount,
          appliedFilters: state.previousState.appliedFilters,
          currentFilters: state.previousState.currentFilters,
          searchText: state.previousState.searchText,
          filteredEntries: state.previousState.filteredEntries,
          // Clear the stored state after restoring
          previousState: null
        };
      }
      return state;

    case TRANSFER_FILTER:
      return {
        ...state,
        TransferRegistration:
          payload === "transfer"
            ? state.registrations.filter((item) => item.status === "Enrollment Submitted")
            : state.TransferRegistration,
        filteredEntries:
          payload === "transfer"
            ? state.registrations.filter((item) => item.status === "Enrollment Submitted")
            : state.registrations,
        InterestListStatus: {
          ...state.InterestListStatus,
          transfer: payload === "transfer",
        },

      }
      case "SET_IS_SEARCH_ACTIVE":
      return {
        ...state,
        searchText: payload,
      };
      
      

    case SEARCH_FILTER:
      const escapedPayload = payload.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`${escapedPayload}`, "gi");

      const filteredEntries =
        state.ageFiltered.length > 0
          ? state.ageFiltered.filter(
            (item) =>
              (item.studentFirstName && item.studentFirstName.match(regex)) ||
              (item.studentLastName && item.studentLastName.match(regex)) ||
              (item.age && item.age.toString().match(regex)) ||
              (item.phone && item.phone.match(regex)) ||
              (item.primaryEmail && item.primaryEmail.match(regex)) ||
              (item.learningCenterName &&
                item.learningCenterName.match(regex)) ||
              (item.learningCenterCharter &&
                item.learningCenterCharter.match(regex)) ||
              (item.learningCenterAddress &&
                item.learningCenterAddress.match(regex)) ||
              (item.parentRelationship &&
                item.parentRelationship.match(regex)) ||
              (item.parentLastName && item.parentLastName.match(regex)) ||
              (item.parentFirstName && item.parentFirstName.match(regex)) ||
              (item.status && item.status.match(regex)) ||
              (item.lastContactDate && item.lastContactDate.match(regex))
          )
          : state.entries.filter(
            (item) =>
              (item.studentFirstName && item.studentFirstName.match(regex)) ||
              (item.studentLastName && item.studentLastName.match(regex)) ||
              (item.age && item.age.toString().match(regex)) ||
              (item.phone && item.phone.match(regex)) ||
              (item.primaryEmail && item.primaryEmail.match(regex)) ||
              (item.learningCenterName &&
                item.learningCenterName.match(regex)) ||
              (item.learningCenterCharter &&
                item.learningCenterCharter.match(regex)) ||
              (item.learningCenterAddress &&
                item.learningCenterAddress.match(regex)) ||
              (item.parentRelationship &&
                item.parentRelationship.match(regex)) ||
              (item.parentLastName && item.parentLastName.match(regex)) ||
              (item.parentFirstName && item.parentFirstName.match(regex)) ||
              (item.status && item.status.match(regex)) ||
              (item.lastContactDate && item.lastContactDate.match(regex))
          );

      const searchFiltered =
        filteredEntries.length > 0 ? filteredEntries : ["No data found"];

      return {
        ...state,
        filteredEntries,
        searchFiltered,
      };

    case CLEAR_AGE_FILTER:
      return {
        ...state,
        ageOver: false,
        ageUnder: false,
        ageFiltered: [],
        filteredEntries:
          state.searchFiltered.length > 0 ? state.searchFiltered : [],
      };
    case CLEAR_NOTINTEREST_FILTER:
      return {
        ...state,
        NotinterestedFiltered: [],
        filteredEntries: state.entries,
        InterestListStatus: {
          ...state.InterestListStatus,
          notInterested: false,
        },
      };

    case CLEAR_TRANSFER_FILTER:
      return {
        ...state,
        TransferRegistration: [],
        filteredEntries: state.entries,
        InterestListStatus: {
          ...state.InterestListStatus,
          transfer: false,
        },
      };
    case CLEAR_SEARCH_FILTER:
      return {
        ...state,
        filteredEntries: state.ageFiltered.length > 0 ? state.ageFiltered : [],
        searchFiltered: [],
      };
    case UPDATE_ENTRIE:
      return {
        ...state,
        entries: state.entries.map((entrie) =>
          entrie._id === action.payload._id ? action.payload : entrie
        ),
      };
    case DELETE_ENTRIE:
      return {
        ...state,
        entries: state.entries.filter(
          (entrie) => entrie._id !== action.payload
        ),
      };
     
    case SET_LIST_VIEW:
      return {
        ...state,
        listView: payload,
      };
    case FILTER_TABLE:
      if (!state.sortOptions[payload]) {
        return state;
      }
      let asc = state.sortOptions[payload].asc === false;
      let normal = state.sortOptions[payload].desc === true;
      return {
        ...state,
        entries: normal
          ? state.entries.sort((a, b) =>
            a["createdAt"] < b["createdAt"] ? 1 : -1
          )
          : asc
            ? state.entries.sort((a, b) => (a[payload] > b[payload] ? 1 : -1))
            : state.entries.sort((a, b) => (a[payload] < b[payload] ? 1 : -1)),
        filteredEntries:
          state.filteredEntries.length > 0
            ? normal
              ? state.filteredEntries.sort((a, b) =>
                a["createdAt"] < b["createdAt"] ? 1 : -1
              )
              : asc
                ? state.filteredEntries.sort((a, b) =>
                  a[payload] > b[payload] ? 1 : -1
                )
                : state.filteredEntries.sort((a, b) =>
                  a[payload] < b[payload] ? 1 : -1
                )
            : [],
        sortOptions: {
          ...{
            createdAt: { asc: false, desc: false },
            age: { asc: false, desc: false },
            studentFirstName: { asc: false, desc: false },
            parentRelationship: { asc: false, desc: false },
            primaryEmail: { asc: false, desc: false },
            phone: { asc: false, desc: false },
            learningCenterName: { asc: false, desc: false },
            status: { asc: false, desc: false },
            lastContactDate: { asc: false, desc: false },
            campaign: { asc: false, desc: false },
            Permalink: { asc: false, desc: false },
          },
          [payload]: normal
            ? { asc: false, desc: false }
            : asc
              ? { asc: true, desc: false }
              : { asc: false, desc: true },
        },
      };
    case CLEAR_FILTER_TABLE:
      return {
        ...state,
        sortOptions: {
          createdAt: { asc: false, desc: false },
          age: { asc: false, desc: false },
          studentFirstName: { asc: false, desc: false },
          parentRelationship: { asc: false, desc: false },
          primaryEmail: { asc: false, desc: false },
          phone: { asc: false, desc: false },
          learningCenterName: { asc: false, desc: false },
          status: { asc: false, desc: false },
          lastContactDate: { asc: false, desc: false },
          campaign: { asc: false, desc: false },
          permalink: { asc: false, desc: false },
        },
      };
    case SET_FORM_MODAL:
      return {
        ...state,
        formModal: { ...state.formModal, [payload.name]: payload.value },
      };
    case 'SET_FILTER_STATE':
      return {
        ...state,
        savedFilters: action.payload
      };

    case 'CLEAR_FILTER_STATE':
      return {
        ...state,
        savedFilters: null
      };

    case "TOGGLE_COLUMN":
      return {
        ...state,
        visibleColumns: {
          ...state.visibleColumns,
          [payload]: !state.visibleColumns[payload],
        },
      };

    default:
      return state;
  }
};

export default adminInterestReducer;
